import { useEffect } from "react";

const setMeta = (selector, attribute, name, content) => {
  if (!content) return;
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

/**
 * Keeps the document's metadata in step with the page being viewed.
 *
 * Only search engines that execute JavaScript see these updates. The static
 * defaults in public/index.html are what a link preview shows — WhatsApp,
 * Facebook and Messenger fetch the HTML and never run the app.
 */
export const useSeo = (seo) => {
  useEffect(() => {
    if (!seo) return;

    if (seo.title) {
      document.title = seo.title;
      setMeta('meta[property="og:title"]', "property", "og:title", seo.title);
      setMeta('meta[name="twitter:title"]', "name", "twitter:title", seo.title);
    }
    if (seo.description) {
      setMeta('meta[name="description"]', "name", "description", seo.description);
      setMeta('meta[property="og:description"]', "property", "og:description", seo.description);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", seo.description);
    }
    if (seo.image) {
      // Link previews reject relative URLs, so make it absolute.
      const image = seo.image.startsWith("http")
        ? seo.image
        : `${window.location.origin}${seo.image}`;
      setMeta('meta[property="og:image"]', "property", "og:image", image);
      setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);
    }

    setMeta('meta[property="og:url"]', "property", "og:url", window.location.href);
    setCanonical(window.location.href);
  }, [seo]);
};
